/*
 * Copyright (c) 2021. American Express Company
 */

export enum BwAlertType {
    GOOD,
    NEUTRAL,
    BAD
}

export class BwAlertViewModel {
    text: string;
    type: BwAlertType;
    action?: string;
    onClick?: (e?: any) => void | Promise<void>;
    className?: string;
    fullWidth?: boolean;
    onClose?: () => void;
    accentIcon?: boolean;
}
